import React, {Fragment} from 'react';
import {useGetEndpointUrl} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages';
import {translations} from 'presentation/translations-new';
import {AlertModal} from '../AlertModal';
import {FooterDesktop} from './FooterDesktop';
import {FooterMobile} from './FooterMobile';
import {StyledFooterWrapper} from './styles';
import {MainFooterProps} from './types';

const {privacyPolicy, serverError, unexpectedError, serverErrorTitle, tryAgain} =
	translations['pt-br'].commons;

export function MainFooter({customMarginBottom, noMargin}: MainFooterProps) {
	const {isMobile} = useMediaQueries();

	const {isError, setIsError, isLoading} = useGetEndpointUrl(privacyPolicy);

	return (
		<Fragment>
			{isMobile ? (
				<StyledFooterWrapper $customMarginBottom={customMarginBottom} $noMargin={noMargin}>
					<FooterMobile isLoading={isLoading} />
				</StyledFooterWrapper>
			) : (
				<StyledFooterWrapper $customMarginBottom={customMarginBottom} $noMargin={noMargin}>
					<FooterDesktop isLoading={isLoading} />
				</StyledFooterWrapper>
			)}
			{isError ? (
				<AlertModal
					open={isError}
					onClose={() => setIsError(false)}
					description={serverError}
					title={serverErrorTitle}
					headerTitle={unexpectedError}
					buttonLabel={tryAgain}
					variant="info"
				/>
			) : null}
		</Fragment>
	);
}
